/**
 * month-label.ts — etykieta miesiąca („wrzesień 2026") z daty ISO. Generyczny helper
 * (bez wiedzy o dokumentach), współdzielony przez `DatePicker mode="month"` i widoki
 * odczytu pól typu „miesiąc".
 */

/**
 * `YYYY-MM-DD` (lub samo `YYYY-MM`) → „wrzesień 2026" w podanym języku; `null` dla pustej
 * albo niepoprawnej wartości (w tym miesiąca spoza 01–12). Dzień nie ma znaczenia —
 * czytamy tylko rok i miesiąc z literału, bez parsowania przez strefę czasową.
 */
export function formatMonthLabel(
  date: string | null | undefined,
  locale: string = 'pl',
): string | null {
  const m = /^(\d{4})-(\d{2})/.exec(date ?? '');
  if (!m) return null;
  const month = Number(m[2]);
  if (month < 1 || month > 12) return null;
  // `new Date(rok, …)` traktuje lata 0–99 jako 1900–1999 — rok ustawiamy osobno.
  const value = new Date(2000, month - 1, 1);
  value.setFullYear(Number(m[1]));
  return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(value);
}
